import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-public-auth-cta',
  standalone: true,
  imports: [
    NgClass,
    ButtonModule,
    TranslateModule
  ],
  templateUrl: './public-auth-cta.component.html',
  styleUrl: './public-auth-cta.component.scss'
})
export class PublicAuthCtaComponent {
  @Input() public compact: boolean = false;

  constructor(
    private readonly router: Router
  ) {
  }

  public goToLogin(): void {
    this.router.navigate(['/login'], {
      queryParams: {
        returnUrl: this.router.url
      }
    });
  }

  public goToRegister(): void {
    this.router.navigate(['/registration'], {
      queryParams: {
        returnUrl: this.router.url
      }
    });
  }
}
